"use client";

import { Check, Loader2, PlayCircle } from "lucide-react";
import { useResumeSubscription } from "@/features/settings/components/api/use-resume-subscription";
import { useI18n } from "@/locales/client";
import { Button } from "../../../components/ui/button";

interface ResumeSubscriptionFormProps {
  onClose: () => void;
}

export function ResumeSubscriptionForm({
  onClose,
}: ResumeSubscriptionFormProps) {
  const t = useI18n();
  const { mutate: resumeSubscription, isPending } = useResumeSubscription();

  const features = [
    t("upgradeModal.aiFeatures.0"),
    t("upgradeModal.aiFeatures.1"),
    t("upgradeModal.aiFeatures.2"),
    t("upgradeModal.aiFeatures.3"),
    t("upgradeModal.aiFeatures.4"),
  ];

  return (
    <div className="flex flex-col gap-6">
      <div className="rounded-lg border bg-muted/50 p-4">
        <div className="flex items-center gap-2 mb-3">
          <PlayCircle className="size-5 text-brand-primary" />
          <p className="font-medium text-sm">
            {t("upgradeModal.paused.resumeLabel")}
          </p>
        </div>
        <ul className="space-y-1.5">
          {features.map((feature) => (
            <li key={feature} className="flex items-center gap-1.5">
              <div className="size-[14px] rounded-full grid place-items-center bg-brand-primary">
                <Check className="size-2 text-white" />
              </div>
              <span className="text-sm">{feature}</span>
            </li>
          ))}
        </ul>
      </div>

      <Button
        className="w-full h-10"
        disabled={isPending}
        onClick={() =>
          resumeSubscription(undefined, { onSuccess: () => onClose() })
        }
      >
        {isPending && <Loader2 className="mr-2 size-4 animate-spin" />}
        {t("upgradeModal.paused.resumeButton")}
      </Button>
    </div>
  );
}
